/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @nx/enforce-module-boundaries */
import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
import {
  AppService,
  NavigationResponse,
} from '@cigna/cigna-for-brokers/shared/data-access';
import { HttpErrorResponse } from '@angular/common/http';
import { take } from 'rxjs/operators';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';
import { AppStateGateway } from '@cigna/cigna-for-brokers/shared/gateways';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'cigna-select-producer-code',
  templateUrl: './select-producer-code.component.html',
  styleUrls: ['./select-producer-code.component.scss'],
})
export class SelectProducerCodeComponent implements OnInit {
  producerCodeList: string[];
  urlLink: string;
  toolsUrl: string;
  apiUrl: string;
  selectedProducerCode: string;
  roles: any;
  selectedRoleId: string;
  selectedBrokerId: string;
  selectedContractValid: string;
  isSingleProducerCode: boolean;
  isCheckExpiredPcode: boolean;
  filterdPcodeList: string[];
  navigationData: NavigationResponse;
  hasIfpAdminMenu: boolean;
  isOktaLoginEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isOktaLoginEnabled',
  ]);

  constructor(
    public dialog: MatDialog,
    private _service: AppService,
    private featureTogglesFacade: FeatureTogglesFacade,
    public _gw: AppStateGateway,
    public dialogRef: MatDialogRef<SelectProducerCodeComponent>,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      urllink: string;
      toolsurl: string;
      data: [];
      rolesdata: [];
      navdata: NavigationResponse;
      hasIfpAdminMenuFlag: boolean;
    },
  ) {}
  redirectToExtUrl(extUrl: string, target: string) {
    this.isOktaLoginEnabled$
      .pipe(take(1))
      .subscribe((isOktaLoginEnabled: boolean) => {
        const isOktaExtRedirectUrl = this.translate.instant(
          `global.isOktaExtRedirectUrl`,
        );
        if (isOktaLoginEnabled && isOktaExtRedirectUrl === 'true') {
          const oktaExtRedirect = this._gw.getOktaExtRedirect(extUrl);
          window.open(oktaExtRedirect, target);
        } else {
          window.open(extUrl, target);
        }
      });
  }

  ngOnInit(): void {
    this.producerCodeList = this.data.data?.sort((x, y) => x - y);
    this.urlLink = this.data.urllink;
    this.roles = this.data.rolesdata;
    this.hasIfpAdminMenu = this.data.hasIfpAdminMenuFlag;
    this.roles.sort(
      (a: { producerCode: number }, b: { producerCode: number }) =>
        a.producerCode > b.producerCode ? 1 : -1,
    );
    this.isSingleProducerCode = false;
    this.isCheckExpiredPcode = false;
    if (this.roles.length === 1) {
      this.selectedRoleId = this.roles[0].roleId;
      this.selectedBrokerId = this.roles[0].brokerId;
      this.selectedContractValid = this.roles[0].isContractValid;
      this.isSingleProducerCode = true;
    }
    if (
      this.urlLink === 'broker.bookOfBusiness.plans' ||
      this.urlLink === 'broker.ifp.compensation'
    ) {
      this.isCheckExpiredPcode = true;
    }
    this.toolsUrl = this.data.toolsurl;
    this.navigationData = this.data.navdata;
    this.autoSelect();
  }

  autoSelect() {
    if (sessionStorage.getItem('spcode')) {
      const codeIs = sessionStorage.getItem('spcode')?.toString() || '';
      this.selectedProducerCode = codeIs;
      this.changeProducerCode(codeIs);
    }
  }

  onCancel() {
    this.dialogRef.close();
  }
  goToURL(): void {
    this.changeProducerCode(this.selectedProducerCode);

    if (this.urlLink === 'broker.quoteEnroll.medical') {
      this.getBrokerQuoteMedical();
    } else if (this.urlLink === 'broker.quoteEnroll.dental') {
      this.getBrokerQuoteDental();
    } else if (this.urlLink === 'broker.bookOfBusiness.plans') {
      this.getBrokerBobPlans();
    } else if (this.urlLink === 'broker.ifp.compensation') {
      this.getIfpCompExt();
    } else if (this.urlLink === 'broker.ifp.rc') {
      this.getIfpResourceCenterExt();
    } else if (
      this.urlLink === 'View License & Appointment Information' ||
      this.urlLink === 'View Documents and Forms' ||
      this.urlLink === 'View and Update Producer Information'
    ) {
      this.apiUrl = `${this.toolsUrl}?roleId=${this.selectedRoleId}&brokerId=${this.selectedBrokerId}`;
      this.redirectToExtUrl(this.apiUrl, '_self');
    } else if (this.urlLink === 'broker.quoteEnroll.medicalextagt') {
      this.getUserSession();
    }
    this.dialogRef.close();
  }
  getUserSession(): void {
    this._service
      .getUserSession(this.selectedRoleId, this.selectedBrokerId)
      .subscribe(
        (response) => {
          if (response.metadata?.outcome?.status === 200) {
            this.getIfpMedicalExtAgent();
          } else {
            window.confirm(response.metadata?.outcome?.message);
          }
        },
        (error: HttpErrorResponse) => {
          window.confirm('You are not authorized to access this request.');
        },
      );
  }
  getIfpMedicalExtAgent(): void {
    this._service.getIfpMedicalExtAgent();
  }
  getBrokerQuoteMedical(): void {
    this._service.getBrokerQuoteMedical(
      this.selectedRoleId,
      this.selectedBrokerId,
    );
  }
  getBrokerQuoteDental(): void {
    this._service.getBrokerQuoteDental();
  }
  getBrokerBobPlans(): void {
    this._service.getBrokerBobPlans(this.selectedRoleId, this.selectedBrokerId);
  }
  getIfpCompExt(): void {
    this._service.getIfpCompExt(this.selectedRoleId, this.selectedBrokerId);
  }
  getIfpResourceCenterExt(): void {
    this._service.getIfpResourceCenterExt(
      this.selectedRoleId,
      this.selectedBrokerId,
    );
  }
  changeProducerCode(ev: string): void {
    this.selectedProducerCode = ev;
    this.roles.forEach((role: any) => {
      if (role.producerCode === ev) {
        this.selectedRoleId = role.roleId;
        this.selectedBrokerId = role.brokerId;
        this.selectedContractValid = role.isContractValid;
        this.isSingleProducerCode = false;
      }
    });
    sessionStorage.setItem('spcode', ev);
  }
}

export interface DialogData {
  users: string[];
}
